import React, { useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import BuildIcon from '@mui/icons-material/Build';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const UnauthorizedPage = () => {
  const { isLoggedIn, currentUser, maintenanceMode, maintenanceEndTime, maintenanceContactUrl } = useAuth();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || (window.location.pathname === '/maintenance' ? 'maintenance' : 'unauthorized');
  const navigate = useNavigate();
  
  // メンテナンスページは常に表示（メンテナンスモードが無効でも表示）
  // 管理者は状況を確認できるように
  
  return (
    <Container maxWidth="md">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          mt: 4, 
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        {mode === 'maintenance' ? (
          // メンテナンスページ表示
          <>
            <Box sx={{ mb: 3 }}>
              <BuildIcon color={maintenanceMode ? "error" : "primary"} sx={{ fontSize: 60 }} />
            </Box>
            <Typography variant="h4" color={maintenanceMode ? "error" : "primary"} gutterBottom>
              {maintenanceMode ? "システムメンテナンス中" : "メンテナンス情報"}
            </Typography>
            {maintenanceMode ? (
              <>
                <Alert severity="error" sx={{ my: 3, mx: 'auto', maxWidth: '80%', justifyContent: 'center' }}>
                  現在、システムのメンテナンスを実施しています。
                  作業終了までしばらくお待ちください。
                </Alert>
                <Typography variant="body1" paragraph>
                  ご迷惑をおかけして申し訳ございませんが、
                  システムの安定稼働と品質向上のため、
                  現在メンテナンス作業を実施しております。
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  メンテナンス終了予定：{maintenanceEndTime || '調整中'}
                </Typography>
              </>
            ) : (
              <>
                <Alert severity="success" sx={{ my: 3, mx: 'auto', maxWidth: '80%', justifyContent: 'center' }}>
                  現在、システムは正常に稼働しています。
                </Alert>
                <Typography variant="body1" paragraph>
                  システムは正常に稼働中です。
                  サービスをご利用いただけます。
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  定期メンテナンス情報や障害情報については、
                  こちらのページで随時お知らせします。
                </Typography>
              </>
            )}
          </>
        ) : (
          // 権限エラー表示
          <>
            <Box sx={{ mb: 3 }}>
              <WarningAmberIcon color="error" sx={{ fontSize: 60 }} />
            </Box>
            <Typography variant="h4" color="error" gutterBottom>
              アクセス権限がありません
            </Typography>
            <Alert severity="warning" sx={{ my: 3, mx: 'auto', maxWidth: '80%', justifyContent: 'center' }}>
              このページを閲覧するための権限がありません
            </Alert>
            <Typography variant="body1" paragraph>
              このページにアクセスするための権限がありません。
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              アクセス権限について質問がある場合は、システム管理者にお問い合わせください。
            </Typography>
          </>
        )}
        
        <Box sx={{ mt: 4 }}>
          {isLoggedIn ? (
            // ログイン済みの場合はホームに戻るボタンを表示
            <Button 
              variant="contained" 
              color="primary" 
              component={Link} 
              to="/"
              sx={{ mr: 2 }}
            >
              ホームに戻る
            </Button>
          ) : (
            // 未ログインの場合はログインボタンを表示
            <Button 
              variant="contained" 
              color="primary" 
              component={Link} 
              to="/login"
              sx={{ mr: 2 }}
            >
              ログイン
            </Button>
          )}
          
          {/* 問い合わせボタン */}
          <Button 
            variant="outlined" 
            color="primary"
            href={maintenanceContactUrl || "mailto:support@example.com"}
          >
            お問い合わせ
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnauthorizedPage; 